import { userService } from "../services";
import config from "../config/config";
import { useSnackbar } from "../components/CommonComponents/SnackbarProvider";

export const DeleteFileAction = {
  deleteFile,
};

async function deleteFile(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.DeleteFile}`;
    debugger;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      // if (response.status != 500) {
      //     return response;
      // } else
      // if (response.status == 401) {
      // } else {
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
